<template>

  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title v-if="isSend" id="dr_title_Send">Send SMS</md-dialog-title>
      <md-dialog-title v-if="isShowLog" id="dr_title_Log">SMS Log</md-dialog-title>
      <md-dialog-title v-if="isShowSMSOutbound" id="dr_title_Log">Send SMS (Outbound)</md-dialog-title>
      <md-dialog-title v-if="isShowLogOutbound" id="dr_title_Log">SMS Log (Outbound)</md-dialog-title>
        <div id="actionButton" style="margin-top: -50px; margin-left: 250px;">
            <md-button class="md-raised custButton" id="closeBtn" @click="cancelAction"><span clas="icons-center material-icons"></span>Close</md-button>
            <md-button class="md-raised custButton" @click="refreshAction" v-if="isRefresh"><span clas="icons-center material-icons"></span>Refresh</md-button>
            <md-button id="sendSMS" :disabled="isdisableSend" class="md-raised custButton" @click="sendSMS" v-if="isSend || isShowSMSOutbound"><span class="icons-center material-icons"></span>Send</md-button>
            <!--
            <span class="result-included-outter-div">
               <span class="result-included-inner-div">
                  <md-radio-group ng-model="radio">
                    <md-radio-button ng-model="web" ng-value="1" aria-label="Web">
                        Web
                    </md-radio-button>
                    <md-radio-button ng-model="mobile" ng-value="2" aria-label="Mobile">
                        Mobile
                    </md-radio-button>
                  </md-radio-group>   
               </span>
            </span>
            -->
         </div> 

      <md-dialog-content >
        <form id="top" @submit.prevent="sendSMS">
        <md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>
        <!--<label name=status id=status style="display:none" ></label> -->
        <md-button type="submit" id="submit" style="display:none;" ></md-button>  
        <span class="info" id="status" style="display:none"></span>


       <div style="width: 1500px; height: 350px"  v-if="isShowSMS"> 
            <pagination :items="loadSendList">
              <template slot-scope="{pageItems}">
                 <md-card class="data-table-container">
                    <div class="outer-container" >
                       <div class="inner-container">
                           <div class="table-header">
                               <table id="headertable">
                                   <thead>
                                     <tr>
                                        <th class="header-cell w10">Load Key</th>
                                        <th class="header-cell w10">Inbound Shipment</th>
                                        <th class="header-cell w10">Driver Name</th>
                                        <th class="header-cell w10">Driver phone#</th>
                                        <th class="header-cell w30">Message</th>
                                        <!--<th width="100%">Message</th>-->
                                     </tr>  
                                   </thead>  
                               </table>  
                           </div> 
                           <div class="table-body" @scroll="handleScroll">
                              <table id="bodytable">
                                <tbody>
                                <tr :key="item.sqeNo" v-for="item in pageItems">
                                 <td class="body-cell w10">{{item.seqNo}}</td>
                                 <td class="body-cell w10">{{item.inboundShipment}}</td>
                                 <td class="body-cell w10">{{item.moveInBy}}</td>
                                 <!--<td class="body-cell w10">{{item.driverPh}}</td>-->
                                 <td class="body-cell w10">
                                     <md-field>
                                        <md-input v-model="item.driverPh"/>
                                     </md-field>  
                                 </td>  
                                 <!--<td class="body-cell w10">{{item.message}}</td>-->
                                 <!--<td class="body-cell w30">-->
                                  <td width="100%">  
                                     <md-field>
                                        <md-input v-model="item.message"/>
                                     </md-field>  
                                 </td>  
                                </tr> 
                                </tbody>
                              </table>
                           </div>   
                       </div>  
                    </div>  
                 </md-card>  
              </template>  
            </pagination>  
        </div>

       <div style="width: 1500px; height: 350px"  v-if="isShowSMSOutbound"> 
            <pagination :items="loadSendList" id="smsoutbound">
              <template slot-scope="{pageItems}">
                 <md-card class="data-table-container">
                    <div class="outer-container" >
                       <div class="inner-container">
                           <div class="table-header">
                               <table id="headertable">
                                   <thead>
                                     <tr>
                                        <th class="header-cell w10">Load Key</th>
                                        <th class="header-cell w10">Container#</th>
                                        <th class="header-cell w10">Driver Name</th>
                                        <th class="header-cell w10">Driver phone#</th>
                                        <th class="header-cell w10">Message</th>
                                     </tr>  
                                   </thead>  
                               </table>  
                           </div> 
                           <div class="table-body" @scroll="handleScroll">
                              <table id="bodytable">
                                <tbody>
                                <tr :key="item.sqeNo" v-for="item in pageItems"  class = "nthRow">
                                 <td class="body-cell w10">{{item.seqNo}}</td>
                                 <td class="body-cell w10">{{item.inboundShipment}}</td>
                          <td> 
                          <div style="min-width:100px" v-if="drivers">
                          <auto-complete-master-data-select
                                  display-type="idOnly"
                                  :prepared-options="drivers"
                                  :init-value-id="item.moveInBy"
                                  :watch-value-id="item.moveInBy"
                                  :on-item-changed="handleDriverChanged(item)"
                                  :createOption = "false"
                                  :reverse = "true"
                                  >
                          </auto-complete-master-data-select>
                          </div>
                          </td>
                          <td class="body-cell w10">
                                     <md-field>
                                        <md-input v-model="item.driverPh"/>
                                     </md-field>  
                          </td>  
                                 <td class="body-cell w10">
                                     <md-field>
                                        <md-input v-model="item.message"/>
                                     </md-field>  
                                 </td>  
                                </tr> 
                                </tbody>
                              </table>
                           </div>   
                       </div>  
                    </div>  
                 </md-card>  
              </template>  
            </pagination>  
        </div>


       <div style="width: 1700px; height: 350px"  v-if="isShowLog || isShowLogOutbound">
         <md-progress-bar  id="pb1" style="display:''" md-mode="indeterminate"/> 
         <calling-api :paths="['/api/w/SendSMS/GetLog']">
            <pagination :items="getSMSLog">
              <template slot-scope="{pageItems}">
                 <md-card class="data-table-container">
                    <div class="outer-container" >
                       <div class="inner-container">
                           <div class="table-header">
                               <table id="headertable">
                                   <thead>
                                     <tr>
                                        <!--<th width="20px">Load Key</th>-->
                                        <th class="header-cell w10" v-if="isShowLog">Inbound Shipment</th>
                                        <th class="header-cell w10" v-if="isShowLogOutbound">Container No.</th>
                                        <th class="header-cell w10">Message ID</th>
                                        <th class="header-cell w10">Driver Name</th>
                                        <th class="header-cell w10">Driver phone#</th>
                                        <th class="header-cell w10">Send By</th>
                                        <th class="header-cell w10">Send Date</th>
                                        <th class="header-cell w10">Message</th>
                                        <th class="header-cell w10">Send From</th>
                                        <th class="header-cell w10">Status</th>
                                     </tr>  
                                   </thead>  
                               </table>  
                           </div> 
                           <div class="table-body" @scroll="handleScroll">
                              <table id="bodytable">
                                <tbody>
                                <tr :key="item.messageId" v-for="item in pageItems">
                                 <!--<td width="20px">{{item.seqNo}}</td>-->
                                 <td class="body-cell w10" v-if="isShowLog">{{item.inboundShipment}}</td>
                                 <td class="body-cell w10" v-if="isShowLogOutbound">{{item.containerNo}}</td>
                                 <td class="body-cell w10">{{item.messageId}}</td>
                                 <td class="body-cell w10">{{item.shortId}}</td>
                                 <td class="body-cell w10">{{item.driverMobile}}</td>
                                 <td class="body-cell w10">{{item.createdBy}}</td>
                                 <td class="body-cell w10">{{item.sendDate}}</td>
                                 <td class="body-cell w10">{{item.message}}</td>
                                 <td class="body-cell w10">{{item.source}}</td>
                                 <td class="body-cell w10">{{item.status}}</td>
                                </tr> 
                                </tbody>
                              </table>
                           </div>   
                       </div>  
                    </div>  
                 </md-card>  
              </template>  
            </pagination>  
         </calling-api>
        </div>

        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
.alwaysShow {
  position: fixed;
  right: 60px;
  top : 30px;
}

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;
}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
  }

  .tab {
      overflow: hidden;
      border: 1px solid #ccc;
      background-color: #f1f1f1;
  }

  .tab button {
      background-color: inherit;
      float: left;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 14px 16px;
      transition: 0.3s;
  }

  .tab button:hover {
      background-color:#ddd;
      text-decoration: underline;
  }

  .tab button:active, button:focus{
      background-color: #ccc;
      text-decoration: underline;
  }

  .tabcontent {
      /*display: none;*/
      padding: 6px 12px;
      border: 1px solid #ccc;
      border-top: none;
      width: 500px;
  }

  .tablinks {
    /*
      font-family: Roboto Slab;
      text-decoration: none;
      font-size: 0.9rem;
    */
      height: 50px;
  }

  .info {
    background-color: #2196f3;
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: white;
    padding: 8px;
    height: 30px;
  }

  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 600px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 100px;
   }

.result-included-inner-div {
    margin-left: 15px;
    font-weight: bold;
    /*margin-bottom: -25px;*/
    margin-top: 5px;
}


</style>


<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "./CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    loadKey: null, 
    shortId: null,
    driverMobile: null,
    inboundShipment: null,
    message: null,
    messageId: null,
    status: null,
    inStartTime: null,
    sendDate: null,
  });

  const getInitialSendSMSInfo = () => ({
    loadKey: null, 
    index: null,
    shortId: null,
    driverMobile: null,
    inboundShipment: null,
    message: null,
    messageId: null,
    status: null,
    sendDate: null,
  });

  const getInitialStatusForm = () => ({
    messageId: null,
    status: null,
    inStartTime: null,
  });

  const getInitialSMSLog = () => ({
      loadKey: null,
      driverMoible: null,
      shortId: null,
      inboundShipment: null,
      containerNo: null,
      message: null,
      status: null,
      sendDate: null,
      messageId: null,
      createdAt: null,
      createdBy: null,
      updatedAt: null,
      updatedBy: null,
    });


  export default {
    components: { callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
      onCreate: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      statusForm: getInitialStatusForm(),
      smslogForm: getInitialSMSLog(),
      sendSMSInfo: getInitialSendSMSInfo(),
      items: [],
      selected:null,
      drivers: [],
      isSMS: true,
      showbar: false,
      isShowLog: false,
      isShowSMS: false,
      isShowSMSOutbound: false,
      isShowLogOutbound: false,
      isdisableSend: false,
      isSend: false,
      isRefresh: false,
      smsLog: [],
      smslist: [],
      sendSMSList: [],
      getLog: [],
      requestdatabackup: null,
      reload: true,
      radio: false,
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getGSTDriverMaster',
        'getGSTDriverTruckLog',
      callingApiCenter,
      ]),
      getGSTDriverTruckLog() {
        console.log("getGSTDriverTrucklog:");
      },  
    filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(null).includes(term)
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },

      getSMSLog(){
        return _(this.smsLog)
        .sortBy(it => it.inboundShipment); 
      },

      loadSendList(){
        var indx = 0;
        // while (this.smslist.length >= indx && this.smslist.length > -1)
        // {
        //    this.smslist[indx].index = indx;
        //    indx += 1;
        // }
        if (this.smslist.length > -1)
        {
           this.smslist.forEach( (it) => {
              it.index = indx;
              indx += 1;
           });
        }
        return _(this.smslist)
        .sortBy(it => it.inboundShipment);
      },

      getLogWithSource() {
         console.log("getLogWithSource");
         alert("radio value: " + this.radio);
      },



    },

    async mounted() {
      const alldrivers = await this.$store.dispatch(
          'getDriversByFSI',
          {
            defaultSalesOffice: 'LGB',
            driverOffice: 'FSI'
          }
      );
      this.drivers = alldrivers;
    },

    watch: {
      getGSTDriverMaster(val) {
        this.updateItems(val);
      },
      getGSTDriverTruckLog(val) {
        console.log("watch method");
        this.updateItems(val);
      }
    },


    validations: {
      dataForm: {
          shortId: {required},
          driverMobile: {required}
      },
    },



    methods: {
      async openDialog(requestdata) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
        console.log("update form: " + this.mode);
        console.log("request data: " + requestdata);
        console.log("mode: " + this.mode);

        if (requestdata) {
          if (this.mode === "SMS")
          {
             console.log("mode in: " + this.mode);
             this.isSMS = true;
             //this.dataForm.driverMobile = requestdata.driverPh;
             //this.dataForm.inboundShipment = requestdata.inboundShipment;
             //this.dataForm.shortId = requestdata.moveInBy;
             //console.log("dataForm: " + this.dataForm.driverMobile + "  " + this.dataForm.inboundShipment + " " + this.dataForm.shortId);
             if (requestdata != null && requestdata.length >= 0)
             {
                console.log("requestdata[0] " + requestdata[0].sqeNo + " shortId: " + requestdata[0].moveInBy);
                //requestdata.forEach( (it) => {
                //   it.driverPh = "+19095695793";
                //   it.message = "test message";
                //});
                //this.smslist = requestdata;
                var smslist_tmp = JSON.parse(JSON.stringify(requestdata));
                console.log("smslist_tmp length: " + smslist_tmp.length);
                smslist_tmp.forEach( (it) => {
                   if (it.driverPh != null && it.driverPh != "")
                   {
                      this.drivers.forEach( (it) => {
                           console.log("this drivers: " + it);

                      })

                   }
                   it.message = "Hi " + it.moveInBy + ", pls download wgt ticket from " + genWgtTicketPDFLink(it.seqNo);
                });
                this.smslist = smslist_tmp;
             }   
             this.isSend = true;
             this.isShowLog = false;
             this.isShowSMS = true;
             this.isShowLogOutbound = false;
             this.isShowSMSOutbound = false;
          }
          if (this.mode === "CALLSMS")
          {
             console.log("mode in: " + this.mode);
             this.isSMS = true;
             //this.dataForm.driverMobile = requestdata.driverPh;
             //this.dataForm.inboundShipment = requestdata.inboundShipment;
             //this.dataForm.shortId = requestdata.moveInBy;
             //console.log("dataForm: " + this.dataForm.driverMobile + "  " + this.dataForm.inboundShipment + " " + this.dataForm.shortId);
             if (requestdata != null && requestdata.length >= 0)
             {
                console.log("requestdata[0] " + requestdata[0].seqNo + " shortId: " + requestdata[0].moveInBy);
                console.log("rec windows: " + requestdata[0].receivingWindows);
                //requestdata.forEach( (it) => {
                //   it.driverPh = "+19095695793";
                //   it.message = "test message";
                //});
                //this.smslist = requestdata;
                var smslist_tmp = JSON.parse(JSON.stringify(requestdata));
                console.log("smslist_tmp length: " + smslist_tmp.length);
                smslist_tmp.forEach( (it) => {
                   if (it.driverPh != null && it.driverPh != "")
                   {
                      this.drivers.forEach( (it) => {
                           console.log("this drivers: " + it);

                      })

                   }
                   it.message = genMapLink(requestdata[0].receivingWindows);
                });
                this.smslist = smslist_tmp;
             }   
             this.isSend = true;
             this.isShowLog = false;
             this.isShowSMS = true;
             this.isShowLogOutbound = false;
             this.isShowSMSOutbound = false;

          }
          if (this.mode === "LOG")
          {
             console.log("mode in: " + this.mode);
             this.showbar = true;
             //this.dataForm.driverMobile = requestdata.driverPh;
             //this.dataForm.inboundShipment = requestdata.inboundShipment;
             //this.dataForm.shortId = requestdata.moveInBy;
             this.isSend = false;
             this.isShowLog = true;
             this.isShowSMS = false;
             this.isShowSMSOutbound = false;
             this.isShowLogOutbound = false;
             this.isRefresh = true;
             this.requestdatabackup = this.requestdata;
             //const req = this.dataForm;
             //document.getElementById("pb").style.display = "";
             if (requestdata != null && requestdata.length > 0)
             {
                console.log("requestdata length " + requestdata.length);
                while (this.getLog.length > 0) {this.getLog.pop()}
                requestdata.forEach( (it) => {
                  console.log("InboundShipment in loop: " + it.inboundShipment);
                  this.smslogForm = getInitialSMSLog();
                  this.smslogForm.inboundShipment = it.inboundShipment;
                  console.log("loadKey: " + it.seqNo + " and actual loadKey: " + it.loadKey);
                  this.smslogForm.loadKey = it.seqNo;
                  this.smslogForm.messageId = "";
                  console.log("smslogForm: " + this.smslogForm.inboundShipment);
                  this.getLog.push(this.smslogForm)
                })
                   
                
             }
             console.log("req size: " + this.getLog.length);
             //console.log("req inboundshipment: " + this.getLog[0].inboundShipment);
             //console.log("req inboundshipment: " + this.getLog[1].inboundShipment)
             //const smsLog = api.post('/api/w/SendSMS/GetLog', req)
             if (document.getElementById("pb1"))
             {
                document.getElementById("pb1").style.display = "";
             }
             //const smsLog = api.post('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
             const smsLog = newAPIPost('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
            .then((it) => {
               this.$store.commit('clearApiError');
               //console.log("response: " + it[0]);
               //console.log("CheckStatus: " + it[0].messageId);
               //console.log("CheckStatusStatus: " + it[0].status);
               console.log("internal var it length: " + it.length);
               this.smsLog = it;
               if (this.smsLog)
               {
                   console.log("smsLog: " + this.smsLog.length);
               }
               //document.getElementById("pb").style.display = "none";
               if (document.getElementById("pb1"))
               {
                  document.getElementById("pb1").style.display = "none";
               }
               this.showbar = false;
            })
          }
          if (this.mode === "SMSOUTBOUND")
          {
             if (requestdata != null && requestdata.length >= 0)
             {
                console.log("requestdata[0] " + requestdata[0].containerNo);
                requestdata.forEach( (it) => {
                   //it.driverPh = "+19095695793";
                   if (it.driverPh != null && it.driverPh != "")
                   {
                       //it.driverPh = "+1" + it.driverPh;
                       console.log("outbound SMS driver phone: " + it.driverPh);
                   }
                   //it.message = "test message";
                   console.log("driver phone: " + it.driverPh);
                   console.log("load key: " + it.seqNo);
                   //it.loadKey = it.sqeNo;
                   it.inboundShipment = it.containerNo;
                   it.shortId = it.moveInBy;
                });
                //this.smslist = requestdata;
                var smslist_tmp = JSON.parse(JSON.stringify(requestdata));;

                //this.smslist = JSON.parse(JSON.stringify(requestdata));
                 smslist_tmp.forEach((it) => {
                     it.driverPh = null;
                     console.log("sqeNo: " + it.seqNo)
                     it.message = "Hi, pls download wgt ticket from " + genWgtTicketPDFLink(it.seqNo);
                 }

                 );
                 this.smslist = smslist_tmp;
             }
              this.isSend = false;
              this.isRefresh = false;
              this.isShowSMS = false;
              this.isShowSMSOutbound = true;
              this.isShowLog = false;
              this.isShowLogOutbound = false;
          }
          if (this.mode === "LOGOUTBOUND")
          {
              this.isSend = false;
              this.isRefresh = true;
              this.isShowSMS = false;
              this.isShowSMSOutbound = false;
              this.isShowLog = false;
              this.isShowLogOutbound = true;

             if (requestdata != null && requestdata.length > 0)
             {
                console.log("requestdata length " + requestdata.length);
                while (this.getLog.length > 0) {this.getLog.pop()}
                requestdata.forEach( (it) => {
                  console.log("inboundShipment in loop: " + it.containerNo);
                  console.log("message Id: " + it.messageId);
                  console.log("loadkey/seqNo: " + it.seqNo);
                  this.smslogForm = getInitialSMSLog();
                  this.smslogForm.inboundShipment = it.containerNo;
                  this.smslogForm.containerNo = it.containerNo;
                  this.smslogForm.messageId = "";
                  this.smslogForm.loadKey = it.seqNo;
                  console.log("smslogForm: " + this.smslogForm.inboundShipment);
                  this.getLog.push(this.smslogForm)
                })
                   
                
             }
             console.log("req size: " + this.getLog.length);
             //console.log("req inboundshipment: " + this.getLog[0].inboundShipment);
             //console.log("req inboundshipment: " + this.getLog[1].inboundShipment)
             //const smsLog = api.post('/api/w/SendSMS/GetLog', req)
             if (document.getElementById("pb1"))
             {
                document.getElementById("pb1").style.display = "";
             }
             //const smsLog = api.post('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
             const smsLog = newAPIPost('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
            .then((it) => {
               this.$store.commit('clearApiError');
               //console.log("response: " + it[0]);
               //console.log("CheckStatus: " + it[0].messageId);
               //console.log("CheckStatusStatus: " + it[0].status);
               console.log("internal var it length: " + it.length);
               this.smsLog = it;
               if (this.smsLog)
               {
                   console.log("smsLog: " + this.smsLog.length);
               }
               //document.getElementById("pb").style.display = "none";
               if (document.getElementById("pb1"))
               {
                  document.getElementById("pb1").style.display = "none";
               }
               this.showbar = false;
            })

          }
        }
        this.showDialog = true;
      },

      updateItems(itemsSource) {
          console.log("itemsSource: " + itemsSource);
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          console.log("items:" + items);
          this.items = items;
      },

      handleScroll(e) {
            $(this.$el.querySelector('.table-header'))
            .offset({
                left: -1 * (e.target.scrollLeft - $('.outer-container')
                .offset().left),
            });
      },


      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },


      handleSalesOfficeChanged(id){
          console.log('saleoffice id:' + id );
          this.dataForm.defaultSalesOffice = id;
      },

      handleDriverTypeChanged(id){
          console.log('Driver Type id:' + id );
          this.dataForm.driverType = id;
      },

      handleDriverStatusChanged(id){
          console.log('Driver Status id:' + id );
          this.dataForm.driverStatus = id;
      },

      handleDriverStateChanged(id){
          console.log('Driver State id:' + id);
          this.dataForm.driverState = id;
      },
      
      handleDriverChanged(item) {
        return (id, name, unit, weight, plate, trail) => {
          //console.log("itsm driverPh: " + item.driverPh);
          //item.driverPh = "";
          console.log(`Item is ${item}`)
          item.moveInBy = id;
          item.driverPh = name;
          console.log(`Phone is ${item.driverPh}`);
          //item.message = "3555";
          //this.$forceUpdate()
          console.log("selected Items driverPh: " + name);
          console.log("selected Items driverPh: " + item.driverPh);
          console.log("selected item index: " + item.index);
          if (item.index > -1)
          {
              console.log("selected item driverPh: " + this.smslist[item.index].driverPh);
          }
          if (document.getElementById("smsoutbound"))
          {
             console.log("find smsoutbound element");
             document.getElementById("smsoutbound").refresh;
          }
        };
      },

      handleCreationDriver()
       {},

      includeNull(field){
                return field==null ? '' : field;
            },



     cancelAction(){
        this.isdisableSend = false;
        this.isRefresh = false;
        this.showDialog = false;
        this.smslog = [];
        this.$store.commit('clearApiError');
     },

     async refreshAction(){
        // const req = this.requestdatabackup;
        // this.getInitialSMSLog();
        // if (req != null && req.length > 0)
        // {
        //    req.forEach( (it) => {
        //        this.smslogForm.inbound
        //    }

        //    )
        // }
        // console.log("inboundshipment: " + this.dataForm.inboundShipment);
        if (document.getElementById("pb"))
        {
           document.getElementById("pb").style.display = "";
        }
        //const refreshLog = api.post('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
        const refreshLog = newAPIPost('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
        .then((it) => {
          console.log("messageId: " + it[0].messageId);
          this.smsLog = it;
          if (document.getElementById("pb"))
          { 
             document.getElementById("pb").style.display = "none";
          }
        }
        )
     },


/*
      async doSaveUser() {
        this.isMain = true;
        this.isDriver = false;
        this.isArea = false;
        this.$v.dataForm.$touch();
        if (this.$v.dataForm.$invalid) {
          return;
        }

        const req = this.dataForm;
       await  api.post("/api/w/gstMasterData/updateDriver", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            console.log("apptNo: " + this.dataForm.apptNo);
            this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.trailernum, this.dataForm.apptNo);
            //this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.apptNo);
            $('.btn-search-master-form-driver')
              .click();
            
          });
      },
*/

      openTab(evt, tabname) {
         /*
         var i, tabcontent, tablinks;

         // Get all elements with class="tabcontent" and hide them
         tabcontent = document.getElementsByClassName("tabcontent");
         for (i = 0; i < tabcontent.length; i++) {
              tabcontent[i].style.display = "none";
         }

         // Get all elements with class="tablinks" and remove the class "active"
         tablinks = document.getElementsByClassName("tablinks");
         for (i = 0; i < tablinks.length; i++) {
             tablinks[i].className = tablinks[i].className.replace(" active", "");
         }

         // Show the current tab, and add an "active" class to the button that opened the tab
         document.getElementById(tabname).style.display = "block";
         evt.currentTarget.className += " active";   
        */
         console.log("tabname: " + tabname);
         
         if (tabname === "Main")
         {
            this.isMain = true;
            this.isDriver = false;
            this.isArea = false;
         }

         if (tabname === "Driver")
         {
            this.isMain = false;
            this.isDriver = true;
            this.isArea = false;
         }

         if (tabname === "Area")
         {
            this.isMain = false;
            this.isDriver = false;
            this.isArea = true;
         }

      },

      async sendSMS() {
         console.log("in sendSMS - driver name: " + this.dataForm.shortId);
         console.log("in sendSMS - driver mobile: " + this.dataForm.driverMobile);
         console.log("in sendSMS - inbound shipment: " + this.dataForm.inboundShipment);
         console.log("in sendSMS - message: " + this.dataForm.message);
         var indx = 0;
         
         this.isdisableSend = true;
         //const req1 = this.dataForm;
         //var sendInfo = this.getInitialSendSMSInfo();
         //const req1 = this.statusForm;
         //req1.driverMobile = "+1" + req1.driverMobile;
         //req1.driverMobile = "+19097849755";
         //req1.driverMobile = "+19095695793";
         //req1.driverMobile = "+19094735544";
         //req1.messageId = "8d2bc293-fe4e-5b93-9235-9bca4a968a38";
         //req1.inStartTime = "2021/07/02 10:00:00";
         while (this.sendSMSList.length > 0) { this.sendSMSList.pop();}
         console.log("smslist length: " + this.smslist.length);
         console.log("smslist 1st inboundShipment: " + this.smslist[0].inboundShipment);
         //console.log("smslist 2nd inboundShipment: " + this.smslist[1].inboundShipment);
         this.smslist.forEach( (it) => {
            this.sendSMSInfo.index = indx;
            if (this.mode === "SMS" || this.mode === "CALLSMS")
            {
               this.sendSMSInfo.inboundShipment = it.inboundShipment;
            }
            else
            {   
               if (this.mode === "SMSOUTBOUND")
               {
                  this.sendSMSInfo.inboundShipment = it.containerNo;
               }
               else
               {
                  this.sendSMSInfo.inboundShipment = "";
               }
            }
            this.sendSMSInfo.loadKey = it.seqNo;
            this.sendSMSInfo.shortId = it.moveInBy;
            this.sendSMSInfo.driverMobile = "+1" + it.driverPh;
            //this.sendSMSInfo.driverMobile = "+19095695793";
            this.sendSMSInfo.message = it.message;
            this.sendSMSInfo.status = "";
            this.sendSMSInfo.sendDate = "";
            this.sendSMSInfo.messageId = "";
            console.log("send loop phone number: " + it.driverPh);
            console.log("send loop phone number: " + this.sendSMSInfo.driverMobile);
            console.log("send loop ibs: " + this.sendSMSInfo.inboundShipment);
            console.log("send loop loadKey: " + this.sendSMSInfo.loadKey);
            console.log("send loop index: " + it.index);
            this.sendSMSList.push(this.sendSMSInfo);
            this.sendSMSInfo = getInitialSendSMSInfo();
            indx += 1;
         });
         console.log("sendSMSList length: " + this.sendSMSList.length);
         console.log("sendSMSList 1st loadKey: " + this.sendSMSList[0].loadKey);
         console.log("sendSMSList 1st inboundShipment: " + this.sendSMSList[0].inboundShipment);
         //console.log("sendSMSList 2nd inboundShipment: " + this.sendSMSList[1].inboundShipment);
         console.log("sendSMSList 1st driverMobile: " + this.sendSMSList[0].driverMobile);
         //console.log("sendSMSList 2nd driverMobile: " + this.sendSMSList[1].driverMobile);
         //console.log("in sendSMS - req1 - driver mobile: " + req1.driverMobile);
         document.getElementById("pb").style.display = "";
         
        
         //const SMSData = api.post('/api/w/SendSMS/Send', { sendInfo: this.sendSMSList})
         const SMSData = newAPIPost('/api/w/SendSMS/Send', { sendInfo: this.sendSMSList})
         .then((it) => {
            this.$store.commit('clearApiError');
            console.log("SMS send done");
            if (it.length > 0)
            {
               console.log("SMSData returns length: " + it.length);
               //console.log("SMSDataStatus: " + it[0].status);
               //req1.messageId = it[0].messageId;
               //req1.inStartTime = "";
               while (this.getLog.length > 0) {this.getLog.pop()}
               it.forEach( (it1) => {
                  this.smslogForm = getInitialSMSLog();
                  this.smslogForm.loadKey = it1.loadKey;
                  console.log("SMSData loadKey: " + it1.loadKey);
                  this.smslogForm.inboundShipment = it1.inboundShipment;
                  this.smslogForm.messageId = it1.messageId;
                  this.smslogForm.driverMobile = it1.driverMobile;
                  this.smslogForm.containerNo = "";
                  //UrlExists(it1.message);
                  this.smslogForm.message = it1.message;
                  this.smslogForm.shortId = it1.shortId;
                  this.smslogForm.sendDate = "";
                  console.log("SMSData messageId: " + it1.messageId);
                  this.smslogForm.inStartTime = "";
                  this.getLog.push(this.smslogForm);
               });
               var req2 = this.getLog;
               if (req2)
               {
                  console.log("req2 length: " + req2.length);
                  setTimeout(function() {disablebar(req2);}, (1 * 1000));
               }
            }
            })
           

           //testing purpose below
           /*
               while (this.getLog.length > 0) {this.getLog.pop()}
               this.smslist.forEach( (it) => {
                  this.smslogForm = getInitialSMSLog();
                  this.smslogForm.inboundShipment = "200894810";
                  this.smslogForm.messageId = "1be607cf-2e30-5d4c-997e-5ea72725e769";
                  console.log("SMSData messageId: " + this.smslogForm.messageId);
                  //console.log("SMSData index: " + it.indx)
                  this.smslogForm.inStartTime = "";
                  this.getLog.push(this.smslogForm);
               });
               var req2 = this.getLog;
          setTimeout(function() {disablebar(req2);}, (1 * 1000)); 
          */
            $('.btn-search-master-form-driver')
              .click();
            
      },

    },
  };

  function disablebar(req) {
    console.log("to disable the bar");
    if (req)
    {
       console.log("req length: " + req.length);
       if (req.length > 0)
       {
          console.log("req messageId: " + req[0].messageId);
          console.log("req loadKey: " + req[0].loadKey);
          console.log("req inboundShipment: " + req[0].inboundShipment);
       }
    }
    var statusObj = null;
            //const CheckStatus = api.post('/api/w/SendSMS/GetMsgStatus', {smsStatus: req})
            const CheckStatus = newAPIPost('/api/w/SendSMS/GetMsgStatus', {smsStatus: req})
            .then((it) => {
              console.log("it length: " + it.length);
              if (it.length > 0)
              {
                 console.log("CheckStatus::messageId: " + it[0].messageId);
                 console.log("CheckStatus::Status: " + it[0].status);
              }
            document.getElementById("pb").style.display = "none";
            statusObj = document.getElementById("status");
            console.log("statusObj: " + statusObj);
            if (statusObj)
            {
               //statusObj.innerText = "Message send status: " + it[0].status;
               statusObj.innerText = "Message sent";
               statusObj.style.display = "";
            }
            if (document.getElementById("closeBtn"))
            {
               document.getElementById("closeBtn").click;
            }
            })
  }

  function sleep(milliseconds) {
         const date = Date.now();
         let currentDate = null;
         do {
           currentDate = Date.now();
         } while (currentDate - date < milliseconds);
  }

  function utc2pst(datetimeInUTC){
         return moment(datetimeInUTC).utc().local().format()  
  }

  function genWgtTicketPDFLink(inbound)
  {
     console.log("getWgtTicketPDFLink: " + inbound);
     var awshost = location.host;
     console.log("origin host: " + awshost);
     if (awshost.includes("-dev.") || awshost.includes("localhost"))
     {
        return "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/WTicket/" + inbound + ".pdf";
     }
     else 
     {
        if (awshost.includes("-qas."))
        {
            return "https://named-account-web-qas.s3.us-west-2.amazonaws.com/PDF/WTicket/" + inbound + ".pdf";
        }
        else
        {
            return "https://named-account-web-prd.s3.us-west-2.amazonaws.com/PDF/WTicket/" + inbound + ".pdf";
        }
     }
  }

  function genMapLink(recwin)
  {
     console.log("genMapLink");
     var awshost = location.host;
     //var fsimsg = "Hello, this is FSI Transloading Inc , please come to scale for your heavy weigh, thank you. Map: ";
     var fsimsg = "Hello, this is FSI Transloading Inc , please come to scale for your heavy weight, thank you.";
     //var wilmsg = "Hello, this is FSI Wilmington Transloading Inc , please come to scale for your heavy weigh, thank you. Map: ";
     var wilmsg = "Hello, this is FSI Wilmington Transloading Inc , please come to scale for your heavy weight, thank you.";
     console.log("origin host: " + awshost);
     if (awshost.includes("-dev.") || awshost.includes("localhost"))
     {
        if (recwin === "185")
           //return fsimsg +
           //"https://named-account-web-dev.s3.us-west-2.amazonaws.com/upload_images/FSI_MAP/FSI.jpg";
           return fsimsg;
        else
           //return wilmsg +
           //"https://named-account-web-dev.s3.us-west-2.amazonaws.com/upload_images/WIL_MAP/Wilmington.jpg";
           return wilmsg;
     }
     else 
     {
        if (awshost.includes("-qas."))
        {
            if (recwin === "185")
               //return fsimsg + "https://named-account-web-qas.s3.us-west-2.amazonaws.com/upload_images/FSI_MAP/FSI.jpg";
               return fsimsg;
            else
               //return wilmsg + "https://named-account-web-qas.s3.us-west-2.amazonaws.com/upload_images/WIL_MAP/Wilmington.jpg";
               return wilmsg;
        }
        else
        {
            if (recwin === "185")
               //return fsimsg + "https://named-account-web-prd.s3.us-west-2.amazonaws.com/upload_images/FSI_MAP/FSI.jpg";
               return fsimsg;
            else
               //return wilmsg + "https://named-account-web-prd.s3.us-west-2.amazonaws.com/upload_images/WIL_MAP/Wilmington.jpg";
               return wilmsg;
        }
     }
  }


  function UrlExists(url) {
     console.log("call UrlExists");
     fetch(url)
     .then(async response => {
        const data = await response.json();
        if (!response.ok) {
           const error = (data && data.message) || response.statusText;
           return Promise.reject(error);
        }
        this.totalVuePackages = data.total;
        console.log("totalVuePackages: " + this.totalVuePackages);
     }
     )
     .catch (error => {
        this.errorMessage = error;
        console.error("There was an error!", error);
     })
  }
</script>